import axClient from './ajax';

export default axClient;
